// Replace this with the shorter optional qualification form once it is ready.
export const WAITLIST_QUALIFY_URL = "https://docs.google.com/forms/d/e/1FAIpQLSchcTfyqkzaas7s26ZrqE8IFufBqHLBKNqxynI5qe1NAQHyBA/viewform?usp=dialog";
export const WAITLIST_SECTION_ID = "hero-waitlist";
export const WAITLIST_SECTION_HREF = `#${WAITLIST_SECTION_ID}`;
export const WAITLIST_SOURCE_HERO = "landing_hero_inline";
export const APP_NAME = "Mindstream";
export const COPYRIGHT_YEAR = 2026;
export const BETA_PRICE_HKD = 3888;
export const MOCK_VALID_BETA_CODE = "BETA-2025";

export const ROLES = ['account executives', 'revenue teams', 'founders', 'operators'];

export const PROBLEMS = [
  {
    title: "Drowning in Communication",
    description: "Professionals spend hours each day reading, replying, and hunting through threads — leaving little time for real work."
  },
  {
    title: "Critical Follow-ups Slip",
    description: "Opportunities, deadlines, and client requests get buried when inboxes overflow and attention is fragmented."
  },
  {
    title: "Broken Manual Workflows",
    description: "Copying tasks into CRMs or spreadsheets is slow, error-prone, and disconnected from the real conversations."
  }
];

export const HOW_IT_WORKS_STEPS = [
  {
    id: "01",
    title: "Connect Gmail (read-only)",
    description: "Secure, read-only access via OAuth. We never send emails or take action without your specific review.",
  },
  {
    id: "02",
    title: "AI processes recent conversations",
    description: "Our engine scans recent threads to extract actionable tasks, priorities, deadlines, owners, and follow-ups.",
  },
  {
    id: "03",
    title: "You get a focused execution dashboard",
    description: "Top 3 Focus items, goal alignment, and ready-to-send reply drafts in seconds.",
  }
];

export const PERSONAS = [
  { title: "Founders & Operators", desc: "Investor threads, customer onboarding, partnerships, ops tasks." },
  { title: "Account Executives", desc: "Deal follow-ups, next steps, pipeline updates, account planning." },
  { title: "RevOps", desc: "CRM hygiene, activity logging, reporting consistency, process enforcement." },
  { title: "B2B Sales", desc: "Lead follow-ups, renewals, customer escalations." },
  { title: "Recruiters", desc: "Candidate scheduling, client updates, offer coordination." },
  { title: "Customer Success", desc: "Renewal tracking, onboarding steps, stakeholder follow-ups, risk signals." },
];

export const VISION_ITEMS = [
  {
    title: "Connected Context",
    description: "Links conversations across inbox, CRM, and docs into one unified working context.",
  },
  {
    title: "Context Awareness",
    description: "Understands the who, what, and why behind tasks without manual explanation or tagging.",
  },
  {
    title: "Compounds Over Time",
    description: "Learns patterns to suggest next steps and reduces missed follow-ups automatically.",
  }
];

export const SECURITY_FEATURES = [
  { text: "Read-only Gmail access" },
  { text: "No emails sent without approval" },
  { text: "Data never used for shared model training" },
  { text: "Disconnect anytime with one click" },
];

export const FAQS = [
  {
    q: "Does Mindstream send emails for me?",
    a: "No. Mindstream drafts replies and follow-ups — you review and send."
  },
  {
    q: "What email access do you need?",
    a: "Read-only Gmail access via OAuth to analyze threads and generate actions/drafts. You can revoke access anytime."
  },
  {
    q: "Do you store my emails?",
    a: "We process email content to extract tasks and context. We store only what's needed to power your workspace (e.g., action items, thread references) and encrypt data at rest and in transit."
  },
  {
    q: "Is my data used to train models?",
    a: "No — your data is never used for model training."
  },
  {
    q: "Who is Mindstream best for?",
    a: "People managing active customer conversations — AEs, RevOps, founders/operators — especially if you live in your inbox daily."
  },
  {
    q: "Who is this not for?",
    a: "If you rarely handle follow-ups, deal threads, or customer coordination in email, you may not get much value yet."
  },
  {
    q: "How much does it cost?",
    a: "We're currently in private beta. Pricing details are shared with invited members. Join the waitlist to get early access."
  },
  {
    q: "When will the beta be available?",
    a: "We're onboarding in waves. Join the waitlist with your email on the landing page, or use an invite code if you already have one."
  },
];

export const NAV_LINKS = [
  { label: 'Features', id: 'features' },
  { label: 'How it works', id: 'how-it-works' },
  { label: 'FAQ', id: 'faq' },
];
